import {
    GET_CATEGORY_LIST_PROGRESS, GET_CATEGORY_LIST_SUCCESS, GET_CATEGORY_LIST_FAILURE,
    ADD_CATEGORY_PROGRESS, ADD_CATEGORY_SUCCESS, ADD_CATEGORY_FAILURE,
    EDIT_DELETE_CATEGORY_PROGRESS, EDIT_DELETE_CATEGORY_SUCCESS, EDIT_DELETE_CATEGORY_FAILURE,
   
    RESET_MESSAGE,

} from '../types/actionTypes';

const initialState = {
    category: [],
    loginUser: null,
    error: false,
    loading: false,
    message: null
}

const category_reducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_CATEGORY_LIST_SUCCESS:
            return { ...state, category: action.category, loading: false };
        case GET_CATEGORY_LIST_FAILURE:
            return { ...state, loading: false, error: true };
        case GET_CATEGORY_LIST_PROGRESS:
            return { ...state, loading: true, error: false };
        case ADD_CATEGORY_PROGRESS:
            return { ...state, loading: true };
        case ADD_CATEGORY_SUCCESS:
            return { ...state, category: [...state.category, action.payload], loading: false, error: false, message: action.payload.message };
        case ADD_CATEGORY_FAILURE:
            return { ...state, loading: false, error: action.payload, message: action.payload.message };
        case EDIT_DELETE_CATEGORY_PROGRESS:
            return { ...state, loading: true };
        case EDIT_DELETE_CATEGORY_SUCCESS:
            return {
                ...state,
                category: state.category.map((category) =>
                category.id === action.payload.id ? action.payload : category
                ),
                message: action.payload.message
            };
        case EDIT_DELETE_CATEGORY_FAILURE:
            return { ...state, loading: false, error: action.payload, message: action.payload.message };
     
        case RESET_MESSAGE:
            return { ...state, message: null }; // Reset the edit message

        default:
            return state
    }
}

export default category_reducer;